import { render, staticRenderFns } from "./LoyaltyPromoLaunchPage.vue?vue&type=template&id=71eb0e6a&scoped=true&lang=pug"
import script from "./LoyaltyPromoLaunchPage.vue?vue&type=script&lang=ts"
export * from "./LoyaltyPromoLaunchPage.vue?vue&type=script&lang=ts"
import style0 from "./LoyaltyPromoLaunchPage.vue?vue&type=style&index=0&id=71eb0e6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eb0e6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VImg,VRow})
